/* eslint-disable max-len */
import { InputSwitch } from 'primereact/inputswitch';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { FaCheck, FaTimes } from 'react-icons/fa';

class InputSwitchButtonComponent extends Component {
    renderView() {
        const { value, label, colClass, id, insideTable } = this.props;
        return <div className={insideTable ? '' : colClass} id={id}>{label} {value ? <FaCheck /> : <FaTimes />}</div>;
    }

    renderEdit() {
        return this.renderNew();
    }

    renderNew() {
        const {
            colClass,
            id,
            insideTable,
            label,
            labelOnLeft,
            name,
            onAfterStateChange,
            onChange,
            showLabel,
            stateField,
            validator,
            validators,
            value,
        } = this.props;
        return (
            <div className={insideTable ? '' : colClass} id={id}>
                <div className={insideTable ? '' : 'row'}>
                    <div className={insideTable ? '' : 'col-md-12 form-group'}>
                        {label !== undefined && showLabel && !labelOnLeft ? (
                            <label id={`${id}-label-id`} className='p-label' htmlFor={id} style={{ width: '100%' }}>
                                {label}
                            </label>
                        ) : null}
                        <div aria-label={label} aria-labelledby={`${id}-label-id`} className='row'>
                            <div className='col-10'>
                                {labelOnLeft ? (
                                    <label
                                        key={`label-${id}-label-id`}
                                        htmlFor={`${id}-input-${label}`}
                                        className='p-inputswitch-label p-label'
                                    >
                                        {label}
                                    </label>
                                ) : null}</div>
                            <div className='col-2'>
                                <InputSwitch checked={value} onChange={(e) => onChange ? onChange('INPUTSWITCH', [name], e, onAfterStateChange, stateField) : null} />
                            </div>
                        </div>
                        <div aria-live='assertive'>{validator ? validator.message(id, label, value, validators) : null}</div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { rendered, viewMode } = this.props;
        if (rendered) {
            switch (viewMode) {
                case 'NEW':
                    return this.renderNew();
                case 'EDIT':
                    return this.renderEdit();
                case 'VIEW':
                default:
                    return this.renderView();
            }
        } else {
            return null;
        }
    }
}

InputSwitchButtonComponent.defaultProps = {
    colClass: 'col-xl-4 col-lg-6 col-md-6 col-sm-12',
    disabled: false,
    insideTable: false,
    itemColClass: 'col-xl-12 col-lg-12 col-md-12 col-sm-12',
    labelOnRight: false,
    rendered: true,
    showLabel: true,
    stateField: 'element',
    validateViewMode: false,
    validators: 'array_required',
    viewMode: 'VIEW',
};

InputSwitchButtonComponent.propTypes = {
    colClass: PropTypes.string,
    disabled: PropTypes.bool,
    id: PropTypes.string.isRequired,
    insideTable: PropTypes.bool,
    itemColClass: PropTypes.string,
    label: PropTypes.string,
    labelOnRight: PropTypes.bool,
    name: PropTypes.string.isRequired,
    onAfterStateChange: PropTypes.func,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.array.isRequired,
    rendered: PropTypes.bool,
    showLabel: PropTypes.bool,
    stateField: PropTypes.string,
    validateViewMode: PropTypes.bool,
    validator: PropTypes.object.isRequired,
    validators: PropTypes.string,
    value: PropTypes.any,
    valueKey: PropTypes.string.isRequired,
    valueLabel: PropTypes.string.isRequired,
    viewMode: PropTypes.string,
};

export default withTranslation()(InputSwitchButtonComponent);
